<template>
  <div class="main">
    <div class="left">
      <div class="left1">
        <div class="leftItem">
          <div>个人信息</div>
          <!-- <div>编辑</div> -->
        </div>
        <div class="left1Item2">
          <img :src="user.userImage" alt="">
          <div class="list">
            <div class="name">
              <div>{{ user.userName }}</div>
              <div>{{ user.userPosition }}</div>
            </div>
            <div class="phone">
              <div>手机号</div>
              <div>{{ user.userPhone }} (如需修改，请到APP端“个人信息”中修改)</div>
            </div>
            <div class="phone">
              <div>修改密码</div>
              <div class="weChat2">
                <el-input v-model="password" show-password />
                <span style="padding: 0 10px;"></span>
                <el-button type="primary" @click="editPassword">确定</el-button>
              </div>
            </div>
            <div class="weChat">
              <div class="weChat1"><span>微信号</span><span>{{ user.wechatAccount ? '当前微信' + user.wechatAccount : '当前未绑定微信'
                  }}</span></div>
              <div class="weChat2">
                <el-input placeholder="请输入" v-model="wechatAccount" />
                <span style="padding: 0 10px;"></span>
                <el-button type="primary" @click="weChat">确定</el-button>
                <!-- <el-button>取消</el-button> -->
              </div>
            </div>
            <div class="email">
              <div class="weChat1">
                <span>接受简历邮箱</span>
                <!-- <span>收到附件简历后自动发送到邮箱</span> -->
                <span style="padding: 0 10px;"></span>
                <el-button type="primary" @click="bindEmail">绑定邮箱</el-button>
              </div>
              <div>{{ user.email ? user.email : '您暂未添加常用邮箱' }}</div>
              <div>
                <el-input placeholder="请输入邮箱" v-model="eMail" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="left2">
        <div>我的公司</div>
        <div>
          <div class="left2Item1">
            <img :src="user.companyImage" alt="">
            <div>
              <div>{{ user.companyName }}</div>
              <div>{{ user.companyAddress }}</div>
            </div>
          </div>
          <!-- <el-button type="primary" icon="el-icon-office-building">公司主页</el-button> -->
        </div>
      </div>
    </div>
    <div class="right">
      <div>更多功能</div>
      <div class="toolList">
        <div class="toolItem" @click="goAddress">
          <img src="../../assets/img/user1.png" alt="">
          <div>地址管理</div>
        </div>
        <div class="toolItem" @click="show = true">
          <img src="../../assets/img/user2.png" alt="">
          <div>问题反馈</div>
        </div>
        <div class="toolItem" @click="chat">
          <img src="../../assets/img/user3.png" alt="">
          <div>我的客服</div>
        </div>
      </div>
    </div>
    <el-dialog title="意见反馈" inline :visible.sync="show">
      <div class="dialog">
        <el-form :model="form" class="form1" ref="form" label-width="70px">
          <el-form-item label="内容描述">
            <el-input type="textarea" v-model="form.feedbackContent" placeholder="请输入问题描述"></el-input>
          </el-form-item>
          <el-form-item label="问题截图">
            <div>最多3张，支持JPG，JPEG，PNG格式(选填)</div>
            <image-upload v-model="form.feedbackImage" :limit="3"></image-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="客服" inline :visible.sync="show1" @opened="open" @close="onClose">
      <div class="rightDown">
        <div class="content" id="content">
          <div v-if="chatMessageList2.length > 0">
            <div class="chatContent" v-for="(item, index) in chatMessageList2" :key="index">
              <div class="chatTime" v-if="item.showTime == 0">{{ item.createTime }}</div>
              <div class="chatOtherSide" v-if="item.targetUserId == memberInfo.companyUserId">
                <img :src="memberInfo.memberUserImage" />
                <div v-if="item.messageType == 1" v-html="item.messageText" class="chatOtherText"></div>
                <div v-if="item.messageType == 2" class="chatImg"><img :src="item.messageText" alt=""></div>
              </div>
              <div class="chatOwn" v-if="item.targetUserId != memberInfo.companyUserId">
                <div v-if="item.messageType == 1" v-html="item.messageText" class="chatText"></div>
                <div v-if="item.messageType == 2" class="chatImg"><img :src="item.messageText" alt=""></div>
                <img :src="memberInfo.companyUserImage" />
              </div>
            </div>
          </div>
          <div class="chatContent" v-for="(item, index) in chatMessageList1" :key="index">
            <div class="chatTime" v-if="item.showTime == 0">{{ item.createTime }}</div>
            <div class="chatOtherSide" v-if="item.targetUserId == memberInfo.companyUserId">
              <img :src="memberInfo.memberUserImage" />
              <div v-if="item.messageType == 1" v-html="item.messageText" class="chatOtherText"></div>
              <div v-if="item.messageType == 2" class="chatImg"><img :src="item.messageText" alt=""></div>
            </div>
            <div class="chatOwn" v-if="item.targetUserId != memberInfo.companyUserId">
              <div v-if="item.messageType == 1" v-html="item.messageText" class="chatText"></div>
              <div v-if="item.messageType == 2" class="chatImg"><img :src="item.messageText" alt=""></div>
              <img :src="memberInfo.companyUserImage" />
            </div>
          </div>
          <div style="height: 50px;" ref="footer"></div>
        </div>
        <div class="msgBox">
          <div class="msgInput" contenteditable></div>
          <div class="sendMsg" @click="sendMsg">
            <span>发送</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {},
      wechatAccount: '',
      show: false,
      show1: false,
      form: {
        feedbackContent: '',
        feedbackImage: ''
      },
      eMail: '',
      chatId: '',
      password: '',
      previousScroll: 0,
      isLastPage: false,
      pageNum: 1,
      socket2: null,
      chatMessageList1: [],
      chatMessageList2: [],
      memberInfo: {}
    }
  },
  created() {
    this.getUserInfo()
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    editPassword() {
      let rule = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}$/
      if(!this.password){
        this.$message({
          message: '密码不能为空',
          type: 'warning'
        })
        return
      }
      if (!rule.test(this.password)) {
        this.$message({
          message: '长度在 8 到 16 个字符且必须包含大写字母，小写字母，数字及特殊字符',
          type: 'warning'
        })
        return
      }
      this.$post('/api/company/companyUser/settingPassword', {
        password: this.password
      }).then(res => {
        if (res.code == 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        }
      })
    },
    bindEmail() {
      this.user.email = this.eMail
      this.$post('/api/company/companyUser/updateCompanyUserInfo', {
        ...this.user
      }).then(res => {
        this.$message({
          message: '邮箱绑定成功',
          type: 'success'
        });
        this.eMail = ''
        this.getUserInfo()
      })
    },
    onClose() {
      this.show1 = false
      // console.log(this.socket2)
      // this.socket2.close()
    },
    open() {
      // console.log(111)
      let el = this.$refs.footer; // 获取目标元素的引用
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到目标元素
      }
      if (document.getElementById('content')) {
        document.getElementById('content').addEventListener('scroll', res => {
          const currentScroll = res.target.scrollTop;
          if (currentScroll > this.previousScroll) {
            // console.log('向下滚动');
            // console.log(currentScroll)
          } else {
            // console.log('向上滚动');
            if (currentScroll < 1) {
              if (this.isLastPage) {
                this.$message('没有更多了')
              } else {
                this.pageNum += 1
                this.getChatMessageList2()
              }
            }
          }
          this.previousScroll = currentScroll;
        });
      }
    },
    chat() {
      this.show1 = true
      this.$post('/api/company/chat/createServiceChatRoom', {}).then(res => {
        this.chatId = res.data.chatId
        this.$get('/api/company/chat/getChatById', {
          chatId: this.chatId
        }).then(res => {
          this.memberInfo = res.data
        })
        this.$get('/api/company/chat/getChatMessageList', {
          chatId: this.chatId,
          pageNum: 1,
          pageSize: 10
        }).then(res => {
          this.chatMessageList1 = res.data.list.reverse()
        })
      })

      if ("WebSocket" in window) {
        let that = this
        that.socket2 = new WebSocket(this.$websocket + '/websocketServer/0/' + that.$cookie.get('companyUserId'))
        that.socket2.addEventListener('open', function () {
          console.log('2连接上了')
        })
        that.socket2.addEventListener('message', res => {
          let el = this.$refs.footer; // 获取目标元素的引用
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到目标元素
          }
          // console.log(res)
          let res1 = JSON.parse(res.data)
          // console.log(res1, 222)
          if (res1.messageText) {
            this.chatMessageList1.push(res1)
            let textDom = document.getElementsByClassName('msgInput')[0]
            textDom.innerHTML = ''
          }
        })

        that.socket2.onclose = res => {
          console.log('关闭了')
        }
      }
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        // 处理回车键按下事件
        this.sendMsg()
      }
    },
    sendMsg() {
      let that = this
      let textDom = document.getElementsByClassName('msgInput')[0]
      let text = textDom.innerHTML
      if (!text) {
        that.$message('不能发送空消息')
        return
      }
      let data = {
        chatId: that.chatId,
        userId: that.$cookie.get('companyUserId'),
        targetUserId: '0',
        messageText: text,
        messageType: 1
      }
      let str = JSON.stringify(data)
      if (that.socket2 !== null && that.socket2.readyState === WebSocket.OPEN) {
        that.socket2.send(str)
      } else {
        console.error('WebSocket断开连接');
      }
    },
    getChatMessageList2() {
      this.$get('/api/company/chat/getChatMessageList', {
        chatId: this.chatId,
        pageNum: this.pageNum,
        pageSize: 10,
      }).then(res => {
        let arr = []
        res.data.list = res.data.list.reverse()
        arr = res.data.list.concat(this.chatMessageList2)
        // console.log(arr)
        this.chatMessageList2 = arr
        this.isLastPage = res.data.isLastPage
      })
    },
    getUserInfo() {
      this.$get("/api/company/companyUser/getCompanyUserInfo", {}).then((res) => {
        this.user = res.data;
        this.wechatAccount = res.data.wechatAccount
        this.$cookie.set('authType', res.data.authType)
        this.$cookie.set('companyName', res.data.companyName)
      });
    },
    weChat() {
      this.user.wechatAccount = this.wechatAccount
      this.$post('/api/company/companyUser/updateCompanyUserInfo', {
        ...this.user
      }).then(res => {
        this.$message({
          message: '微信号修改成功',
          type: 'success'
        });
      })
    },
    submit() {
      this.$post('/api/company/platform/submitFeedback', { ...this.form }).then(res => {
        this.$message({
          message: '反馈成功，请耐心等待',
          type: 'success'
        });
        this.show = false
      })
    },
    goAddress() {
      this.$router.push('/address')
    }
  }
}
</script>
<style scoped>
.main {
  padding: 30px;
  display: flex;
}

.left {
  width: 60%;
}

.left1 {
  background: #FFFFFF;
}

.leftItem {
  padding: 20px;
  display: flex;
  justify-content: space-between;
}

.leftItem>div:nth-of-type(1) {
  width: 72px;
  height: 25px;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.leftItem>div:nth-of-type(2) {
  width: 56px;
  height: 28px;
  background: #0051AA;
  border-radius: 2px;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.left1Item2 {
  display: flex;
  padding: 20px;
}

.left1Item2>img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 30px;
}

.list>div {
  margin-bottom: 30px;
}

.name>div:nth-of-type(1) {
  height: 25px;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.name>div:nth-of-type(2) {
  height: 22px;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.phone>div {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.weChat1>span:nth-of-type(1) {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.weChat1>span:nth-of-type(2) {
  margin-left: 20px;
  font-weight: 500;
  font-size: 14px;
  color: #777777;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.weChat2 {
  display: flex;
  margin-top: 10px;
}

.email>div:nth-of-type(2) {
  display: flex;
  font-weight: 500;
  font-size: 14px;
  color: #555555;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.left2 {
  height: 114px;
  padding: 20px;
  margin-top: 20px;
  background: #FFFFFF;
}

.left2>div:nth-of-type(1) {
  width: 72px;
  height: 25px;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.left2>div:nth-of-type(2) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}

.left2Item1 {
  display: flex;
}

.left2Item1>img {
  width: 60px;
  height: 60px;
  background: #F5F7FB;
  border-radius: 4px;
  margin-right: 30px;
}

.left2Item1>div>div:nth-of-type(1) {
  height: 25px;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.left2Item1>div>div:nth-of-type(2) {
  height: 22px;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.right {
  width: 34%;
  height: 645px;
  padding: 20px;
  margin-left: 20px;
  background: #FFFFFF;
}

.right>div:nth-of-type(1) {
  width: 72px;
  height: 25px;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.toolList {
  display: flex;
  margin-top: 20px;
}

.toolItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 70px;
  cursor: pointer;
}

.toolItem>img {
  width: 30px;
  height: 30px;
}

.toolItem>div {
  width: 56px;
  height: 20px;
  margin-top: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #4A4A4A;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.rightDown {
  margin-top: 10px;
}

.content {
  /* width: 900px; */
  height: 450px;
  padding-top: 50px;
  /* 指定元素的高度 */
  background-color: #FFFFFF;
  overflow-y: scroll;
  overflow-x: hidden;
  /* 当内容超过高度时显示滚动条 */
}

.chatContent {
  width: 100%;
  padding: 0 20px;
}

.chatTime {
  width: 100%;
  height: 30px;
  margin-top: 50px;
  font-weight: 400;
  font-size: 22px;
  color: #9A9A9A;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.chatOtherSide {
  max-width: 90%;
  display: flex;
  margin-top: 20px;
}

.chatOtherSide>img {
  width: 76px;
  height: 76px;
}

.chatOtherText {
  max-width: 60%;
  background-color: #FFFFFF;
  padding: 20px;
  margin-left: 10px;
  border-radius: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #4A4A4A;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.chatOwn {
  display: flex;
  margin-top: 20px;
  margin-right: 40px;
  justify-content: flex-end;
}

.chatText {
  max-width: 60%;
  height: 100%;
  padding: 10px;
  background-color: #2D81E3;
  border-radius: 10px;
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.chatImg {
  width: 200px;
  height: 200px;
}

.chatImg>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.chatOwn>img {
  width: 76px;
  height: 76px;
  margin-left: 10px;
}

.msgBox {
  height: 150px;
  border-top: 1px solid #EBEBEB;
  background-color: #FFFFFF;
  padding: 10px;
  position: relative;
}

.msgInput {
  width: 850px;
  border: none;
  height: auto;
  outline: none;
}

.sendMsg {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 62px;
  height: 30px;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
}
</style>